// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.payments.RentalManagerUserPropertyPaymentWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod,
  RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPaymentDefaultPaymentMethodResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetDefaultPaymentMethodParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Options = UseQueryOptions<
  UserPaymentDefaultPaymentMethodResponseWebDto,
  unknown,
  UserPaymentDefaultPaymentMethodResponseWebDto,
  readonly [string, GetDefaultPaymentMethodParams]
>;

const RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_GetKey = (
  getParams: GetDefaultPaymentMethodParams,
) => [RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Path, getParams] as const;

export const RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_queryOptions = (
  getParams: GetDefaultPaymentMethodParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user default payment method
 */
export const useRentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod = (
  getParams: GetDefaultPaymentMethodParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod.getKey =
  RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_GetKey;
